import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['One worksheet per theme, one goal at a time', 'Works for one student, hard to stretch across a group', 'A monthly fee that never ends', 'Color printing, cutting and laminating', 'You still decide what each student does on Tuesday'];
const withIt = ['72 ready sessions across a full school year', 'A goal row for every student in the group', 'Start, Build and Stretch levels — pre-readers included', 'One payment — no subscription', 'Open the theme, place each student, run it'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-324" data-mp="2965vvtts7l78">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-325" data-mp="2d8kecctjgixz">
        <div className="text-center" data-id="element-326" data-mp="2d6pqapmz0apo">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-327" data-mp="30xv654swv2zz">
            Why this isn&apos;t another no-prep bundle
          </p>
          <h2 id="vs-heading" className="mt-3 font-display text-plum text-3xl sm:text-5xl" data-id="element-328" data-mp="35r7urexlb9sq">
            Themed worksheets vs{' '}
            <span className="text-coral-deep" data-id="element-329" data-mp="1ohl4w47iprrz">a stacked session</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-330" data-mp="235fx7jhm5u4j">
            Most speech therapy materials give you more pages, or a monthly
            feed of new ones. More pages was never the hard part — running one
            session that fits four different goals at the same table was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl border border-cream-dark" data-id="element-331" data-mp="2m4k5gq1bzjv5">
          <div className="bg-cream px-3.5 py-4 sm:p-6" data-id="element-332" data-mp="2h4fl2oxay4zn">
            <h3 className="font-display text-base text-ink-soft sm:text-xl" data-id="element-333" data-mp="2h2uqx0ewgo2b">
              A no-prep bundle or a monthly membership
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-334" data-mp="mrpvgjdyvhy2">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-335" data-mp="2mtpg8lnolhcd">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-336" data-mp="2vtu81nge675f">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-337" data-mp="30tgmu1bvbvgc" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-plum px-3.5 py-4 text-white sm:p-6" data-id="element-338" data-mp="3aos3ip6u7cqq">
            <h3 className="font-display text-base text-gold sm:text-xl" data-id="element-339" data-mp="3fid48oztektm">
              Session Ready SLP
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-340" data-mp="3jlj4ng08xhs6">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-341" data-mp="3okckvg6x3mw1">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-342" data-mp="7h6t65uk4hdp">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-343" data-mp="2fhg6knrxtmz" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}